import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a1e018b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-2 items-center" }

import {computed} from "vue";
import Card from "@/Components/General/Card.vue";
import {Option} from "@/types/LevelsSelectTypes/index";

import {mdiArrowRightBottom, mdiCheckCircle} from "@mdi/js";
import SvgIcon from '@jamescoyle/vue-icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionBox',
  props: {
    option: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const selectedClasses = computed(() => {
  if (props.selected) {
    return "md:bg-gray-300 dark:bg-gray-600 dark:bg-opacity-100 focus:outline-none focus-visible:outline-black dark:focus-visible:outline-white border border-gray-200 dark:border-gray-600 hover:bg-grey-100 rounded";
  }

  return "";
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid option-box gap-2 cursor-pointer transform transition-all duration-200 place-content-center bg-slate-100 border border-grey-900 h-10 mt-1 mb-1 p-4", selectedClasses.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.selected)
        ? (_openBlock(), _createBlock(_unref(SvgIcon), {
            key: 0,
            type: "mdi",
            class: "text-green-700 w-6 h-6 mr-2",
            path: _unref(mdiCheckCircle)
          }, null, 8, ["path"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(SvgIcon), {
        type: "mdi",
        class: "w-4 h-4",
        path: _unref(mdiArrowRightBottom)
      }, null, 8, ["path"])
    ]),
    _createElementVNode("h4", null, _toDisplayString(_ctx.option.label), 1)
  ], 2))
}
}

})